<template>
  <div v-if="item" :ref="`shopItemId_${item.shopItemId}`" :class="{hidden: isHiddenItem}" @click.stop="setDetail(item.shopItemId)">
    <div ref="itemThumb" class="thumb notranslate">
      <div v-if="hasOptionItem" class="optionStkr" :style="getDefaultBtnStyle">{{ locale.option }}</div>
      <div v-if="getPromotion">
        <!-- <ItemPromotion
          v-for="(promotion, index) in getPromotion"
          :key="index"
          :locale="locale"
          :promotion="promotion"
          :thumbWidth="thumbWidth" /> -->
        <div v-for="(items, key) in getPromotion" :key="key" :style="getPromotionPosition(key)" class="promotions">
          <ItemPromotion
            v-for="(promotion, index) in items"
            :key="index"
            :locale="locale"
            :promotion="promotion"
            :thumbWidth="thumbWidth" />
        </div>
      </div>
      <img v-if="item.thumb" :src="item.thumb" :alt="item.name" />
      <!-- <img v-if="item.thumb"
        :src="getThumbnail(item.thumb)"
        :alt="item.name"
        @error="onThumbnailError($event, item.thumb)" /> -->
      <div v-if="!isAvailable" class="disabledMessage notranslate">{{ locale.not_available }}</div>
      <div v-else-if="getStatus" class="disabledMessage">{{ getStatus[lang] }}</div>

      <div v-if="isStore && orderCooldown && !item.status && !item.isAvailable" class="itemCooldown">
        <i class="icoCooldown"></i>
        {{ orderCooldownMessage }}
      </div>

    </div>
    <div v-if="!isHiddenAvailableTime && getAvailableTime && availableMessage" class="itemInfo notranslate">
      <!-- 이용시간 -->
      <div
        @click.stop="availableTable = true"
        :class="{disabled: !isAvailable}"
        class="availableTime">
        <span
          v-for="(time, index) in availableMessage"
          :key="index"
          class="timeItem">
          {{ time }}
        </span>
      </div>
      <!-- //이용시간 -->
    </div>

    <div v-if="item.quantityByOrder" :style="remainStyle" class="remainQuantity notranslate">
      <span>{{ locale.reamin_order_quantity }}: {{ possibleMax }}{{ locale.unit_item }}</span>
    </div>
    <div
      :style="nameStyle"
      class="name">
      {{ item.shopItemName[lang] || item.shopItemName[defaultLang] }}
    </div>
    <div
      :style="priceStyle"
      class="price notranslate">
      {{ displayPrice }}
    </div>
    <AvailableTable
      v-if="getAvailableTime && availableTable"
      :locale="locale"
      :lang="lang"
      :table="getAvailableTime"
      @close="availableTable = false" />
  </div>
</template>

<script>
import moment from 'moment/moment'
import regExp from '@/common/regExp'
import AvailableTable from '@/components/Util/AvailableTable'
import ItemPromotion from './ItemPromotion'
import { timeState } from './timeTicker'
import { isAvailableNow } from '@/common/availableTimeChecker'

export default {
  name: 'ShopItem',
  props: [
    'locale',
    'lang',
    'shopPageId',
    'item',
    'isAuth',
    'settings',
    'itemCategory',
    'categoryItemLimit'
  ],
  components: {
    AvailableTable,
    ItemPromotion
  },
  computed: {
    now () {
      return timeState.now
    },
    defaultLang () {
      return this.$store.getters['common/getDefaultLang']
    },
    siteCommon () {
      return this.$store.getters['common/getSetting']
    },
    isStore () {
      return this.$route.name === 'store'
    },
    getShopGuest () {
      return this.$store.getters['shop/getShopGuest']
    },
    getAvailableTime () {
      const presetId = (!this.isAuth && this.item && this.item.displayTime )|| this.item && this.item.availableTime
      return this.$store.getters['shop/getPresetProperty']('availableTime', (presetId || null))
    },
    isAvailableComputed () {
      const now = this.now
      const availableTime = this.getAvailableTime
      return isAvailableNow(Array.isArray(availableTime) ? availableTime : [], now)
    },
    availableMessage () {
      const timeTable = this.getAvailableTime
      if (!timeTable) return '00:00-24:00'
      const today = moment().isoWeekday() - 1
      const day = timeTable[today]
      return day && day.available ? day.time.map((x) => `${x.from}-${x.to}`) : ['Day off']
    },
    getPromotion () { // 프로모션 스티커
      const presetIds = this.item.promotions || (this.item.promotion ? [this.item.promotion] : null)
      const promotionPresets = presetIds ? presetIds.map(presetId => this.$store.getters['shop/getPresetProperty']('promotion', presetId)) : []
      return promotionPresets.filter(item => item).reduce((acc, item) => { // 포지션을 키로 하는 객체
        const pos = item.position
        if (!acc[pos]) acc[pos] = []
        acc[pos].push(item)
        return acc
      }, {})
    },
    getStatus () { // 판매불가 상태인 아이템
      const presetId = this.item.status
      const preset = presetId && this.$store.getters['shop/getPresetProperty']('status', presetId)
      return (presetId && preset && preset.text) || null
    },
    replaceOptionPrice () { // 옵션들의 선택항목들 이름+금액
      const itemPrice = Number(this.price || 0)
      const itemOptions = this.itemOptions
      const extractOptions = extractOptionItems(itemOptions, itemPrice).filter(x => x.price)
      function extractOptionItems (optionItem, itemPrice) {
        const result = []
        for (const key in optionItem) {
          const item = optionItem[key]
          item.optionItems.forEach(opt => {
            result.push({
              name: (opt.replaceNameOnList && opt.replaceName ) || opt.name,
              price: Number(opt.price || 0) + itemPrice
            })
          })
        }
        return result
      }
      return this.item.replaceOptionPrice ? extractOptions : null
    },
    price () {
      const priceInfo = this.item && this.item.priceInfo
      // const itemPrice = priceInfo && priceInfo.gross
      const itemPrice = this.$store.getters['shop/getItemPrice'](this.shopPageId, this.item.shopItemId)
      return itemPrice
    },
    displayPrice () {
      const optionPrice = this.item && this.item.replaceOptionPrice ? this.replaceOptionPrice : null
      // 임시로 2개, 에디터에 개수 설정 후 itemProperty에 추가할 예정
      const optionPriceSplitItem = (this.item && this.item.replaceOptionPriceSplitItem) || 2
      return optionPrice
        ? this.replaceOptionPrice.filter((x, i) => optionPriceSplitItem && (i < optionPriceSplitItem)).map(x => {
          return `${x.name[this.lang]} ${Number(x.price) > 0 ? this.priceFormat(x.price) : ''}`
        }).join(' / ')
        : Number(this.price) > 0
          ? this.priceFormat(this.price)
          : ''
    },
    nameStyle () {
      const fontSize = 1 + (parseInt(this.settings.itemFontSize) - 2) * 0.1 // default: 2(1em)
      const align = this.settings.itemAlignName
      return this.settings && {
        fontSize: `${fontSize}em`,
        textAlign: align
      }
    },
    remainStyle () {
      const fontSize = 0.75 + (parseInt(this.settings.itemFontSize) - 2) * 0.1 // default: 1.2(0.6em)
      const align = this.settings.itemAlignName
      return this.settings && {
        marginBottom: '0.5em',
        fontSize: `${fontSize}em`,
        textAlign: align,
        opacity: 0.6
      }
    },
    priceStyle () {
      const fontSize = 1 + (parseInt(this.settings.itemPriceSize) - 2) * 0.1 // default: 2(1em)
      const align = this.settings.itemAlignPrice
      return this.settings && {
        fontSize: `${fontSize}em`,
        textAlign: align
      }
    },
    getDefaultBtnStyle () {
      return this.$store.getters['common/getDefaultBtnStyle']
    },
    hasOptionItem () {
      const option = this.item.optionProperty || this.item.option
      return option && option.length > 0
    },
    isHiddenAvailableTime () {
      const settings = this.$store.getters['shop/getShopSettings'](this.shopPageId)
      const isHidden = settings && settings.hiddenAvailableTime
      return isHidden
    },
    isHiddenItem () {
      const hiddenByAvailableTime = !this.isAvailable && this.isHiddenAvailableTime === true
      const hiddenByInactive = this.item && this.item.isActive === false
      return hiddenByAvailableTime || hiddenByInactive
    },
    isValid () {
      const isAuth = this.$store.getters['authentication/isAuth']
      return isAuth
    },
    // 실제 선택 가능한 수량 최대치
    possibleMax () {
      const shopPageId = this.shopPageId
      const shopCatCode = this.$store.getters['shop/getShopCatCode'](shopPageId)
      const shopItemId = this.item.shopItemId
      return this.$store.getters['shop/getItemPossibleMax'](shopCatCode, shopItemId, this.isStore)
    },
    // 주문대기 시간 체크
    orderCooldown () {
      const shopPageId = this.shopPageId
      const shopCatCode = this.$store.getters['shop/getShopCatCode'](shopPageId)
      const getWaitingOrder = this.$store.getters['shop/getWaitingOrder'](shopCatCode)
      const isIgnoreCooldown = this.item.ignoreLimit && this.item.ignoreLimit.waiting
      return isIgnoreCooldown ? null : getWaitingOrder
    },
    orderCooldownMessage () {
      const cooltime = this.orderCooldown
      return cooltime && this.locale.message_order_cooldown.replace('{var}', cooltime)
    }
  },
  watch: {
    isHiddenItem (isHidden) {
      this.$store.commit('shop/setHiddenItem', { shopItemId: this.item.shopItemId, isHidden: isHidden })
    },
    isAvailableComputed: {
      immediate: true,
      handler (val) {
        this.isAvailable = val
      }
    },
    'item.option': {
      immediate: true,
      deep: true,
      async handler () {
        await this.syncItemOptions()
      }
    },
    'item.optionProperty': {
      immediate: true,
      deep: true,
      async handler () {
        await this.syncItemOptions()
      }
    },
    'item.replaceOptionPrice': {
      immediate: true,
      async handler () {
        await this.syncItemOptions()
      }
    }
  },
  async mounted () {
    this.$nextTick(() => {
      this.getThumbWidth()
    })
  },
  data () {
    return {
      availableTable: false,
      checkAvailable: 0,
      isAvailable: true,
      itemOptions: {},
      thumbWidth: 285,
      itemOptionsRequestId: 0
    }
  },
  methods: {
    async syncItemOptions () {
      this.itemOptions = {}

      if (!(this.item && this.item.option && this.item.replaceOptionPrice)) return

      const requestId = ++this.itemOptionsRequestId

      if (this.item.optionProperty) {
        this.itemOptions = this.item.optionProperty
        return
      }

      const optionIds = this.item.option.filter(x => x.id).map(x => x.id)
      const createOptions = this.item.option.filter(x => x.optionId)

      const replaceOption = optionIds.length > 0
        ? await this.$store.dispatch('shop/getStoreOptionItems', {
          shopItemId: this.item.shopItemId,
          ids: optionIds
        })
        : null

      if (requestId !== this.itemOptionsRequestId) return

      const optionItem = replaceOption && replaceOption.message && replaceOption.message.optionItem

      let nextItemOptions = optionItem || {}

      if (createOptions && createOptions.length > 0) {
        createOptions.forEach(item => {
          nextItemOptions = {
            ...nextItemOptions,
            [item.optionId]: item
          }
        })
      }

      this.itemOptions = nextItemOptions
    },
    getThumbWidth () {
      const thumb = this.$refs && this.$refs.itemThumb
      this.thumbWidth = thumb && thumb.offsetWidth
    },
    getThumbnail(url) {
      if (!url || typeof url !== 'string') return ''

      // 이미 썸네일이면 그대로
      if (/_thumb\.webp$/i.test(url)) {
        return url
      }

      return url.replace(/\.[^.]+$/, '_thumb.webp')
    },

    onThumbnailError(event, originUrl) {
      if (!originUrl || typeof originUrl !== 'string') return

      if (event.target.src !== originUrl) {
        event.target.src = originUrl
      }
    },
    getPromotionPosition (position) {
      const promotionPosition = {
        ...position === 'tr' && {
          top: 0,
          right: 0
        },
        ...position === 'tl' && {
          top: 0,
          left: 0
        },
        ...position === 'br' && {
          bottom: 0,
          right: 0,
          alignItems: 'flex-end'
        },
        ...position === 'bl' && {
          bottom: 0,
          left: 0,
          alignItems: 'flex-end'
        }
      }
      return {
        ...promotionPosition
      }
    },
    priceFormat (price) {
      const shopPageId = this.shopPageId
      const currency = this.$store.getters['shop/getShopCurrency'] || null
      return this.$store.getters['util/getPriceFormatter'](price, currency)
    },
    setDetail (shopItemId) {
      const shopPageId = this.shopPageId
      const shopCatCode = this.$store.getters['shop/getShopCatCode'](shopPageId)
      const billingCount = (shopCatCode && Number(this.$store.getters['shop/getBillingCountByShopItemId'](shopCatCode, shopItemId))) || 0
      const hasOption = this.item.option && this.item.option.length > 0
      // const itemMin = this.item.quantityByOrder && billingCount && 1
      // console.log(itemMin)
      const detailInfo = {
        shopItemId: shopItemId,
        categoryId: this.itemCategory,
        price: this.price,
        pId: this.item.pId,
        selectQuantity: {
          min: 1,
          max: 10,
          ...this.item.quantity
        },
        hasOption: hasOption,
        selectOptionByQuantity: (this.item.selectOptionByQuantity && hasOption) || false,
        ...this.item.isCallItem && {
          isCallItem: this.item.isCallItem
        },
        ...this.item.availableTime && {
          availableTime: this.item.availableTime
        },
        ...this.item.status && {
          status: this.item.status
        },
        ...this.item.passFirstOption && {
          passFirstOption: this.item.passFirstOption
        },
        ...this.item.isCallItem && {
          isCallItem: this.item.isCallItem
        }
      }
      const cartData = {
        payload: {
          ...detailInfo,
          totalPrice: this.price || 0,
          createat: new Date().toISOString(),
          updateat: new Date().toISOString(),
          shopItemName: this.item.detailShopItemName && this.item.detailShopItemName.active // 상세이름 별도설정 (포스상품명으로 보통 사용)
            ? this.item.detailShopItemName.shopItemName
            : this.item.shopItemName,
          priceInfo: this.item.priceInfo,
          ...normalizeQuantity({
            quantity: 1,
            selectQuantity: detailInfo.selectQuantity,
          }, detailInfo.selectOptionByQuantity, this.possibleMax),
          ...this.item.thumb && {
            thumb: this.item.thumb
          }
        },
        shopPageId: shopPageId,
        shopItemId: shopItemId,
        catCode: shopCatCode
      }
      function normalizeQuantity (input, selectOptionByQuantity, possibleMax) {
        const data = { ...input } // 원본 보존
        const sq = data.selectQuantity || {}

        const toNum = v => (v === null || v === undefined ? undefined : Number(v))
        const isFiniteNum = v => Number.isFinite(v)

        const min = toNum(selectOptionByQuantity ? 1 : sq.min)
        const max = toNum(sq.max)

        // 상한 결정: possibleMax 우선, 없으면 max, 둘 다 없으면 Infinity
        const upper = isFiniteNum(possibleMax)
          ? possibleMax
          : (isFiniteNum(max) ? max : Infinity)

        // 특수 규칙(4): min > possibleMax 이면 quantity = possibleMax
        if (isFiniteNum(min) && isFiniteNum(possibleMax) && min > possibleMax) {
          data.quantity = Math.floor(possibleMax)
          return data
        }

        // 기본 클램프
        let q = toNum(data.quantity)
        if (!isFiniteNum(q)) q = 1 // 비정상 값 대비 기본값
        q = Math.floor(q) // 정수화

        if (isFiniteNum(min) && q < min) q = Math.floor(min)
        if (q > upper) q = Math.floor(upper)

        data.quantity = q
        return data
      }
      // 설명 없고 옵션 없으면 바로 장바구니 담기
      if (this.isAvailable && !(this.item.descList && this.item.descList.length > 0) && !(this.item.optionProperty && this.item.optionProperty.length > 0) && !(this.item.detailImage && this.item.detailImage.length > 0)) {
        if (this.item.status) {
          this.$emit('setToastMessage', this.getStatus[this.lang])
          return
        }
        if (this.categoryItemLimit && this.categoryItemLimit.possibleMax === 0) {
          this.$emit('setToastMessage', this.locale.over_limit_category_count)
          return
        }
        if (this.possibleMax === 0) {
          this.$emit('setToastMessage', this.locale.over_limit_category_count)
          return
        }
        this.$emit('addCart', cartData)
        return
      }
      this.$store.commit('shop/setDetailItem', detailInfo)
    }
  }
}
</script>
